// @owners { team: patients }
export const isRebateProgram = (billableType: string) => billableType === 'rebate';
